
import { CATEGORY_PAGE_API } from '../config/apiPoints';
import { fetchHelper } from '../../utils/fetchHelper';

export const prepareCategoryPageRequest = (params) => {
  const url = `${__ENV_CONFIG__.__PAGEROVER__}${CATEGORY_PAGE_API}${params.pageType}`
  return url;
}

export const getCategoryPageData = async (params) => {
  const url = prepareCategoryPageRequest(params);
  let data = {}
  try {
    data = await fetchHelper({
      name: 'category page',
      type: 'GET',
      url: url,
    });
  } catch (err) {
    data = { status: false, error: true }
  }
  return data;
}
